import { MultilineAddressToolkit } from '@wix/form-multiline-address';
import { EMPTY_VALUE } from '../../constants';
import { normalizeLoadedFormValues } from '../../field-viewer/normalize-loaded-form-values';
export function normalizeMultilineAddress({ fieldValue, addressTemplates, field, viewers }) {
    const isEmptyValue = fieldValue === EMPTY_VALUE;
    if (isEmptyValue) {
        return EMPTY_VALUE;
    }
    const addressForms = addressTemplates?.map((template)=>template.template);
    if (!addressForms) {
        return EMPTY_VALUE;
    }
    const addressToolkit = new MultilineAddressToolkit(addressForms);
    const country = fieldValue?.country;
    const template = addressToolkit.getFormByCountry(country, field);
    return normalizeLoadedFormValues(viewers, template, fieldValue, true, addressTemplates);
}

//# sourceMappingURL=multiline-address-normalize-value.js.map